import React from 'react';
import PropTypes from 'prop-types';

import {
  FACEBOOK_SHARE_URL,
  TWITTER_SHARE_URL,
  LINKEDIN_SHARE_URL,
  POPUP_SHARE_PROPERTIES,
  SHARE_EMAIL_TEMPLATE,
} from 'consts';
import ButtonLink from '../buttons/ButtonLink';

const SocialMediaIcons = props => {
  const openFacebook = () => {
    const sharerUrl = `${FACEBOOK_SHARE_URL}?u=${props.referralUrl}/${props.slug}&title=${props.projectTitle}
    &caption=&quote=`;
    openWindow(sharerUrl);
  };

  const openTwitter = () => {
    const sharerUrl = `${TWITTER_SHARE_URL}?text=${props.projectTitle} ${props.referralUrl}/${props.slug}`;
    openWindow(sharerUrl);
  };

  const openLinkedin = () => {
    const sharerUrl = `${LINKEDIN_SHARE_URL}&url=${props.referralUrl}/${props.slug}`;
    openWindow(sharerUrl);
  };

  const openWindow = sharerUrl => {
    window.open(sharerUrl, 'targetWinow', POPUP_SHARE_PROPERTIES);
    return false;
  };

  return (
    <div className="project-share-icons">
      <ButtonLink id="facebook-share" className="p-0" onClick={openFacebook}>
        <div className="icon-facebook-1" />
      </ButtonLink>
      <ButtonLink id="twitter-share" className="p-0" onClick={openTwitter}>
        <div className="icon-twitter-1" />
      </ButtonLink>
      <ButtonLink id="linkedin-share" className="p-0" onClick={openLinkedin}>
        <div className="icon-linkedin-1" />
      </ButtonLink>
      <a target="_blank" rel="noopener noreferrer" href={SHARE_EMAIL_TEMPLATE}>
        <div className="icon-email-1" />
      </a>
    </div>
  );
};

SocialMediaIcons.propTypes = {
  referralUrl: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
  projectTitle: PropTypes.string.isRequired,
};

export default SocialMediaIcons;
